import React, { useRef, useState } from 'react';

import './style.css';
const OtpInputWithValidation = ({ numberOfDigits, onOtpChange }) => {
	const [otp, setOtp] = useState(new Array(numberOfDigits).fill(''));
	const otpBoxReference = useRef([]);

	const handleChange = (value, index) => {
		let newArr = [...otp];
		newArr[index] = value;
		setOtp(newArr);

		// Call the onOtpChange prop with the new OTP string
		const newOtpString = newArr.join('');
		if (newOtpString.length === numberOfDigits) {
			handleOtpChange(newOtpString);
			return;
		}

		if (value && index < numberOfDigits - 1) {
			otpBoxReference.current[index + 1].focus();
		}
	};

	//handles otp value passing to Parent Component
	const handleOtpChange = otpString => {
		if (!otpString) return;
		otpString && onOtpChange && typeof onOtpChange === 'function' && onOtpChange(otpString);
	};

	const handleBackspaceAndEnterKeyUp = (e, index) => {
		// Handle other keyUp events like Enter if necessary
		if (e.key === 'Enter' && index < numberOfDigits - 1) {
			otpBoxReference.current[index + 1].focus();
		}
	};

	const handleBackspaceAndEnterKeyDown = (e, index) => {
		if (e.key !== 'Backspace') {
			return;
		}
		// If current input is empty and we're not at the first input,
		// move focus to the previous input and clear its value
		if (otp[index] === '' && index > 0) {
			const newOtp = [...otp];
			// Focus the previous input
			const prevIndex = index - 1;
			otpBoxReference.current[prevIndex].focus();
			// If the previous input also empty, clear the value
			if (newOtp[prevIndex] === '') {
				newOtp[prevIndex] = '';
				setOtp(newOtp);
			}
			e.preventDefault();
		} else {
			// If the current input is not empty, clear its value
			const newOtp = [...otp];
			newOtp[index] = '';
			setOtp(newOtp);
		}
	};

	//handles on paste action and spread the otp value on the inputs
	const handlePaste = e => {
		e.preventDefault();
		const pasteData = e.clipboardData.getData('text').slice(0, numberOfDigits);
		const newOtpArray = pasteData.split('');

		// Check if all characters are digits and if the length matches the number of digits required
		if (newOtpArray.every(char => /\d/.test(char)) && newOtpArray.length === numberOfDigits) {
			setOtp(newOtpArray);
			handleOtpChange(newOtpArray.join('')); // Pass the new OTP to the parent component

			otpBoxReference.current[newOtpArray.length - 1].focus();
		}
	};

	return (
		<div className="OtpInputWithValidation">
			{otp.map((digit, index) => (
				<input
					key={index}
					value={digit}
					maxLength={1}
					onChange={e => handleChange(e.target.value, index)}
					onKeyUp={e => handleBackspaceAndEnterKeyUp(e, index)}
					onKeyDown={e => handleBackspaceAndEnterKeyDown(e, index)}
					onPaste={handlePaste}
					ref={reference => (otpBoxReference.current[index] = reference)}
					className="OtpInputWithValidation__Input"
				/>
			))}
		</div>
	);
};

export default OtpInputWithValidation;
